import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LevelsService } from '@services/levels.service';
import { NewphaseComponent } from './newphase/newphase.component';
import Swal from 'sweetalert2';
import { PhaseService } from '@services/phase.service';
import { DownloadService } from '@services/download.service';
import { ToastrService } from 'ngx-toastr';
import { GeminiBatchService } from '@services/gemini-batch.service';

@Component({
  selector: 'app-leveldetail',
  templateUrl: './leveldetail.component.html',
  styleUrls: ['./leveldetail.component.css']
})
export class LeveldetailComponent implements OnInit {

  level:any;
  id: any;
  loading = false;
  startingBatch = false;
  constructor(
    private modal:NgbModal,
    private phaseService:PhaseService,
    private languageService:LevelsService,
    private route:ActivatedRoute,
    private router:Router,
    private downloadService:DownloadService,
    private toastr: ToastrService,
    private geminiBatchService: GeminiBatchService
    ) {


  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
          this.getLangs();
  }



  upload(event){

    const file:File = event.target.files[0];

    const formData = new FormData();

    formData.append("excel", file);

    this.loading = true;

    this.downloadService.bulkupload(formData,this.id).subscribe(res=>{

      this.toastr.success('Kelime yükleme başarılı!');

      this.loading = false;
    },err=>{
      this.toastr.error('Hata oluştu! dosyayı kontrol edin.');
      this.loading = false;
    });

  }


  getLangs(){
     this.languageService.get(this.id).subscribe(res=>{
      this.level=res;
     })
  }

  startAiBatch(kind: 'Question' | 'WordMeanings'){
    const isWordMeanings = kind === 'WordMeanings';
    Swal.fire({
      title: isWordMeanings ? 'AI Kelime Anlamı Üretimi' : 'AI Soru Üretimi',
      text: isWordMeanings
        ? "Bu seviyedeki, sorusu üretilmiş ama kelime anlamları henüz üretilmemiş kelimeler için OpenAI batch işi başlatılacak. Onaylıyor musunuz?"
        : 'Bu seviyedeki, sorusu henüz üretilmemiş tüm aktif kelimeler için OpenAI batch işi başlatılacak. Onaylıyor musunuz?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, başlat',
      cancelButtonText: 'İptal',
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.startingBatch = true;
      this.geminiBatchService.startBatchForLevel(this.id, kind).subscribe({
        next: (job) => {
          this.toastr.success(`Batch işi başlatıldı (${job.keywordCount} kelime). Durumu 'AI Batch İşleri' sayfasından takip edebilirsiniz.`, 'Başarılı');
          this.startingBatch = false;
        },
        error: (err) => {
          const message = err?.error || 'Batch işi başlatılırken hata oluştu.';
          this.toastr.error(message, 'Hata');
          this.startingBatch = false;
        }
      });
    });
  }


  openSaveModal(){
    const modalref=  this.modal.open(NewphaseComponent, { size: 'lg' });
    modalref.componentInstance.levelid=this.id;
    modalref.result.then((result)=>{
     this.getLangs();
    });

    }


    edit(data:any){
      const modalref=  this.modal.open(NewphaseComponent, { size: 'lg' });
      modalref.componentInstance.levelid=this.id;
      modalref.componentInstance.data=data;
      modalref.result.then((result)=>{
       this.getLangs();
      });
    }

  detail(data:any){
    this.router.navigate(["/phasedetail/"+data])
  }
  delete(data:any){

    Swal.fire({
      title: 'Dikkat',
      text: "Bu aşama silinecek! Onaylıyor musunuz?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet',
      cancelButtonText: 'İptal',
    }).then((result) => {


      if (result.isConfirmed) {

          this.phaseService.delete(data).subscribe(res=>{
              this.getLangs();
              Swal.fire(
                  'Başarılı!',
                  'aşama silindi',
                  'success'
                )
          });

      }
    })

  }


}
